<template>
    <b-modal
      no-close-on-backdrop
      centered
      ok-only
      size="md"
      ok-title="Fechar"
      ok-variant="danger"
      v-model="open"
      title="Excluir colaborador"
      hide-footer
      :busy="loading"
    >
      <b-row v-if="loading">
        <b-col cols="12" class="text-center">
          <b-spinner label="Spinning"></b-spinner>
        </b-col>
      </b-row>
     
      <b-row v-else class="container text-center">
        <b-col cols="12">
          <h4 class="text-center">Desja realmente excluir o(a)  {{name}}?</h4>
        </b-col>

        <b-col cols="6" class="mt-5">
          <b-button
            variant="danger"
            class="btn-block"
            @click="open = false"
          > 
            Não
          </b-button>
        </b-col>

        <b-col cols="6" class="mt-5">
          <b-button
            variant="success"
            class="btn-block"
            @click="deleteUser()"
          > 
            Sim 
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </template>
  
  <script>
  import makeToast from '@/mixins/makeToast';
  
  export default {
    name: 'ModalDeleteClerk',
    mixins: [makeToast],
    $emits: ['clerkUpdate'],
   
    data() {
      return {
        loading: false,
        open: false,
        idUser: '',
        name: ''
      };
    },

  methods: {
    toggleOpen({id, name}) {
      this.open = !this.open;
      this.idUser = id;
      this.name = name;
    },

    deleteUser(){
      this.loading = true;

      this.$store.dispatch('shopkeeper/deleteClerk', this.idUser)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Dados apagados com sucesso!',
            'success'
          );
          
          this.$emit('clerkUpdate');
          this.open = !this.open;
          })
          .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados',
            'danger'
          );
          })
          .finally(() => {
            this.loading = false;
          })
      },
    },
  };
  </script>
  